import { Manager } from '../Manager';
import Core from '../../Core/Core';
import Board from '../Board/Board';
import { Actions } from '../../State/Actions/Actions';
import { BoosterUtils } from './BoosterUtils';
import LevelView from '../../View/LevelView';

export default class Magnet extends Manager {
    private view: LevelView;
    private board: Board;

    constructor(view: LevelView, board: Board) {
        super();

        this.view = view;
        this.board = board;
    }

    public cleanUp() {
        super.cleanUp();
    }

    public async triggerMagnetPulls(): Promise<void> {
        Core.store.dispatch(Actions.blockBoard(true));
        const state = Core.store.getState();
        const {
            StateLevel: { selected },
        } = state;
        const magnetId = selected[0];
        this.board.magnetShow(magnetId);
        const pulls = BoosterUtils.startMagnetPull(state, this.countMagnet.bind(this));

        let res = null;
        while (!res || !res.done) {
            // @ts-ignore
            const r = res && res.value ? res.value : null;
            res = await pulls.next(r);
        }

        this.completeMagnet();
    }

    private countMagnet(
        magnetId: string,
        magnetScore: number,
        id: string,
        score: number,
        delay: number,
        playSound: boolean = false
    ): void {
        this.board.magnetPull(id, magnetId, score);
        if (playSound) {
            this.view.playMagnetPullSound(delay + 850);
        }
        if (score !== 0) {
            Core.store.dispatch(Actions.setMultiplier(1));
        }
        Core.store.dispatch(Actions.addScore(magnetScore));
        Core.store.dispatch(Actions.removeStoredPairs(id));
    }

    private completeMagnet(): void {
        Core.store.dispatch(Actions.blockBoard(false));
        Core.store.dispatch(Actions.boosterActionComplete());
    }
}
